import { render, staticRenderFns } from "./RolePermissions.vue?vue&type=template&id=0d0cb323&scoped=true&"
import script from "./RolePermissions.vue?vue&type=script&lang=js&"
export * from "./RolePermissions.vue?vue&type=script&lang=js&"
import style0 from "./RolePermissions.vue?vue&type=style&index=0&id=0d0cb323&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d0cb323",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d0cb323')) {
      api.createRecord('0d0cb323', component.options)
    } else {
      api.reload('0d0cb323', component.options)
    }
    module.hot.accept("./RolePermissions.vue?vue&type=template&id=0d0cb323&scoped=true&", function () {
      api.rerender('0d0cb323', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/permissions/RolePermissions.vue"
export default component.exports